import { Outlet } from '@tanstack/react-router';
import { InfluencersSearchProvider } from './influencers-search-context';

export const InfluencersSearch = () => (
  <InfluencersSearchProvider>
    <Outlet />
  </InfluencersSearchProvider>
);
